import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 24,
  },
  description: {
    marginTop: theme.spacing(2),
  },
  fieldLabel: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  select: {
    height: 50,
  },
  selectForm: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      width: '100%',
      height: 40,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/Budget/useStyles.js